<template>
  <b-table :fields="fields" :items="items" :busy="loading" thStyle="style">
    <template v-slot:table-colgroup="scope">
      <col
        v-for="field in fields"
        :key="field.key"
        :style="{ width: field.key === 'accountId' ? '40%' : '15%' }"
      />
    </template>

    <template v-slot:cell(accountId)="data">
      <div v-if="!data.item.isNew">{{ data.item.accountId }}</div>
      <div v-if="data.item.isNew">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="1234567890" v-model="data.item.accountId" />
          <div class="input-group-append">
            <button class="btn btn-primary" type="button" @click="saveId(data.item)">
              <i class="text-white ki icon-sm ki-check"></i>
            </button>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:cell(name)="data">
      {{ data.item.name }}
    </template>

    <template v-slot:cell(isConfirmed)="data">
      <span
        class="label label-xl"
        :class="data.item.isConfirmed ? 'label-success' : 'label-danger'"
      >
        <i
          class="ki icon-sm text-white"
          :class="data.item.isConfirmed ? 'ki-check' : 'ki-close'"
        ></i>
      </span>
    </template>

    <template v-slot:cell(status)="data">
      <span class="switch switch-outline switch-icon switch-success">
        <label>
          <input
            type="checkbox"
            v-model="data.item.status"
            name="select"
            :disabled="data.item.isNew"
            @change="changeStatus(data.item)"
          />
          <span></span>
        </label>
      </span>
    </template>

    <template v-slot:cell(delete)="data">
      <button
        class="btn btn-default btn-sm text-center"
        @click="deleteId(data.item)"
      >
        <i class="flaticon2-rubbish-bin-delete-button icon-nm text-center pr-0"></i>
      </button>
    </template>
  </b-table>
</template>

<script>
export default {
  name: "AdsTable",
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      style: {}
    };
  },
  methods: {
    deleteId(obj) {
      this.$emit("delete", obj);
    },
    saveId(obj) {
      if (!obj.accountId.length) {
        return;
      }
      this.$emit("save", obj);
    },
    changeStatus(obj) {
      this.$emit("status", obj);
    }
  }
};
</script>

<style scoped></style>
